function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M18.9 3.294a10.953 10.953 0 0 0-15.66 0c-4.32 4.392-4.32 11.53 0 15.922a10.953 10.953 0 0 0 15.66 0c4.32-4.392 4.32-11.53 0-15.922zm-.756 15.153c-3.888 3.953-10.206 3.953-14.148 0-3.888-3.953-3.888-10.376 0-14.384C7.884.11 14.202.11 18.144 4.063c3.888 3.953 3.888 10.431 0 14.384zm2.376 1.867l-1.08 1.098L25.92 28 27 26.902l-6.48-6.588z"
});

var SvgMagnifyingGlass = function SvgMagnifyingGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagnifyingGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifying-glass.6bf6c057.svg";
export { ForwardRef as ReactComponent };